import {observer} from 'mobx-react';
import {Layout, Panel, Select2, Display} from 'shared/components';
import {withState, t} from 'shared/core';
import {TaskEditState} from '../state';
import {auth} from 'main/tools';
import {ModalButtons} from 'shared/components/modals';
import {TaskTemplateFields} from 'main/components/tasks';

const TaskEditContainer = observer(({uiState}) => {
  const {taskTemplate, taskTemplateForm, employeeGroups, config, errors} = uiState;

  return (
    <div>
      <Display backPath={`/tasks/${config.templateType}`}/>
      <Layout>
        <Panel>
          <Panel.Header
            title={t(`company_settings.tasks.${config.templateType}.name`)}
            description={t(`company_settings.tasks.${config.templateType}.description`)}
          />
          <TaskTemplateFields taskTemplateForm={taskTemplateForm} errors={errors}/>
          <Select2
            label='company_settings.tasks.Assign by default for'
            value={taskTemplate.employeeGroupId}
            placeholder='company_settings.tasks.Select Employee Group'
            onChange={e => uiState.employeeGroupSelected(e.target.value)}
            allowClear
            helpLink={{
              explanation:
                { header: t('company_settings.tasks.Default Task Assignment'),
                  paragraphs: [
                    t(`company_settings.tasks.${config.templateType}.DEFAULT_ASSIGN_EXPLAINER`),
                    t(`company_settings.tasks.${config.templateType}.DEFAULT_ASSIGN_EXPLAINER_2`)
                  ]
                }
          }}
          >
            {employeeGroups.map((group) =>
              <option key={group.id} value={group.id}>{group.name}</option>
            )}
            {auth.hasAccess('::MANAGE_EMPLOYEE_GROUPS') && <option value={'createNewEmployeeGroup'}>{t('company_settings.tasks.+ Create New Employee Group')}</option>}
          </Select2>
          <ModalButtons
            saveCaption={`${taskTemplate.isNew ? 'Create' : 'Save'}`}
            onSave={() => uiState.saveTaskTemplate()}
            onCancel={() => uiState.goBack()}
          />
        </Panel>
      </Layout>
    </div>
  );
});

export default withState(TaskEditContainer, TaskEditState);
